import { ReactNode, useContext } from 'react';
import Typography from '@alltrails/core/components/Typography';
import Heading from '@alltrails/denali/components/Heading';
import { ModalAriaLabelledByContext } from '@alltrails/modal/components/Modal/ModalAriaLabelledByContext';
import styles from './ModalTitle.module.scss';

type Props = {
  subtitle: ReactNode;
  title: ReactNode;
};

export default function ModalTitle({ subtitle, title }: Props) {
  const ariaLabelledBy = useContext(ModalAriaLabelledByContext);

  return (
    <div className={styles.title}>
      <Heading as="h2" id={ariaLabelledBy} size="400">
        {title}
      </Heading>
      <Typography color="secondary" component="div" variant="text200">
        {subtitle}
      </Typography>
    </div>
  );
}
